import styled from 'styled-components'

import { SEARCH_BAR_SECOND_LINE_BREAK } from '@/constants/others'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const ToolsContainer = styled.div(
  ({ theme }) => `
  align-items: center;
  display: flex;
  margin-left: ${theme.spacing.default};
  order: 2;
  white-space: nowrap;

  ${SEARCH_BAR_SECOND_LINE_BREAK} {
    flex-grow: 1;
    justify-content: flex-end;
    margin-left: unset;
    order: 3;
    margin-top: ${theme.spacing.mini};
  }
`
)

export const HiddenMobile = styled.span(
  ({ theme }) => `
  display: none;

  ${MEDIA_QUERIES(theme).medium} {
    display: contents;
  }
`
)
